import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController'
import {createDivIn, createImgIn, createLinkIn, createParagraphIn, setElementInnerText, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {getNotificationIconForType, NotificationContentType} from '../../../shared/scripts/ui_utils/NotificationUtils'

export class UIMNotificationView {
    private readonly notificationContainer: HTMLDivElement
    protected readonly notification: HTMLDivElement
    private readonly textContainer: HTMLParagraphElement
    private readonly crossImage: HTMLImageElement
    private removeAction: (() => void) | undefined

    readonly type: UITopNotificationType
    readonly contentType: NotificationContentType

    constructor(title: TranslationObject, type: UITopNotificationType, buttonText?: TranslationObject, action?: (() => void) | undefined, removeAction?: (() => void) | undefined, contentType: NotificationContentType = NotificationContentType.General, showCloseButton: boolean = true,
                duration?: number) {
        this.type = type
        this.contentType = contentType
        this.removeAction = removeAction

        this.notificationContainer = this.getNotificationContainer()
        this.notification = createDivIn(this.notificationContainer, 'm-notification') as HTMLDivElement
        createImgIn(this.notification, getNotificationIconForType(this.type), 'm-notification-img')
        this.textContainer = createParagraphIn(this.notification, title, 'm-notification-text') as HTMLParagraphElement
        this.createButton(buttonText, action)

        if(duration !== undefined) {
            setTimeout(() => {
                this.close()
            }, duration)
        }

        if(showCloseButton == false) return

        this.crossImage = createImgIn(this.notification, LobbyImage.XMark, 'm-corner-notification-cross')
        setElementOnClick(this.crossImage, () => {
            this.close()
        })
    }

    private getNotificationContainer() {
        if(this.type == UITopNotificationType.SocketError) return document.getElementById('m-fullscreen-notification-container') as HTMLDivElement
        return document.getElementById('m-notification-container') as HTMLDivElement
    }

    close() {
        this.notification.remove()
        if(this.removeAction != undefined) this.removeAction()
    }

    private createButton(buttonText?: TranslationObject, action?: () => void) {
        if(buttonText == undefined || action == undefined) return
        const button = createLinkIn(this.textContainer, '', buttonText, 'm-notification-action')
        setElementOnClick(button, () => {
            UIMNotificationView.hideStoreGiftOverlay()
            this.close()
            action()
        })
    }

    static hideStoreGiftOverlay() {
        const storeGiftOverlays = document.getElementsByClassName('store-gift-overlay-container')
        if(storeGiftOverlays.length > 0) Array.from(storeGiftOverlays).forEach((overlay) => overlay.classList.add('hidden'))
    }

    updateText(newText: TranslationObject) {
        setElementInnerText(this.textContainer, newText)
    }

    updateRemoveAction(removeAction: () => void) {
        this.removeAction = removeAction
    }
}
